module.exports = __webpack_public_path__ + "static/media/ic-outlet-img-placeholder.b442a805.svg";